import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=fb7bd69e"
import script from "./AddressSelect.vue?vue&type=script&lang=js"
export * from "./AddressSelect.vue?vue&type=script&lang=js"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=fb7bd69e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports